import MoveOutDetails from './MoveOutDetails'
import InstructionsAndInfo from './InstructionsAndInfo'
import { useNavigate, useParams } from 'react-router'
import { useCallback, useEffect, useState } from 'react'
import { DocumentService, EntityType, LeaseAgreementService, MoveTypesEnum, PaidFlowTypesEnum, PayeeAccountTypesEnum, PaymentService, TenantService } from '@propertelligent/client-api'
import apiHelper from '../../../utils/apiHelper'
import { convertStreamAndDownloadBymimeTypes } from '../../../utils/helper'
import { useError } from '../../../utils/context/ErrorContext'
import { UserLoginData } from '../../common/charts/Enums'
import DateHelper from '../../../utils/DateHelper'
import UtilHelper from '../../../utils/UtilHelper'
import { Accordion, AccordionSection } from '../../../newComponents/card/accordion'
import SimpleButton from '../../../newComponents/buttons/Simple-button'
import LeftArrowTopHeader from '../../../newComponents/form-fields/LeftArrowTopHeader'
import { ConfirmationPopup } from '../../../newComponents/confirmation-popup/confirmation-popup-demo'
import { URLS } from '../../../constants/constants'
import DynamicAddMoreForm from '../../common/DynamicAddMoreForm'
import { NotificationType, PubSub, TopicsEnum } from '../../../utils/pubsub'

/** Single payment row in the form (id can be server id or temporary local id) */
interface PaymentFormItem {
    id: number;
    paymentType: string | number;
    amount: string | number;
    dueDate: string;
    gracePeriods: string | number;
    description: string;
    isNonRefundable?: boolean;
}

const DEFAULT_PAYMENT_ITEM: PaymentFormItem = {
    id: 1,
    paymentType: "",
    amount: "",
    dueDate: "",
    gracePeriods: "",
    description: "",
    isNonRefundable: false,
};

interface AccordionState {
    movein: boolean;
    paymentInfoOpen: boolean;
    notes: boolean;
}
const initialAccordionState: AccordionState = {
    movein: true,
    paymentInfoOpen: false,
    notes: false,
};

const MoveInAndOutContentBlocks = ({ leaseApplicationId = null, tenantData = null, isMoveOut = false, show = false, setCurrentStep = (val: any) => { } }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [accordionState, setAccordionState] = useState<AccordionState>(initialAccordionState);
    const [existingPaymentIds, setExistingPaymentIds] = useState<number[]>([]);
    const [pickupInstruction, setPickupInstruction] = useState("")
    const [additionalInfo, setAdditionalInfo] = useState("")
    const [loadingStates, setLoadingStates] = useState({ userData: true });
    const [moveOutDate, setMoveOutDate] = useState("");
    const [moveOutReason, setMoveOutReason] = useState([]);
    const [showModal, setShowModal] = useState(false)
    const [leaseAgreementData, setLeaseAgreementData] = useState<any>()
    const [moveInId, setMoveInId] = useState()
    const [moveOutId, setMoveOutId] = useState()
    const [tenantMoveId, setTenantMoveId] = useState()
    const [userData, setUserData] = useState<any>()
    const [formData, setFormData] = useState<PaymentFormItem[]>([{ ...DEFAULT_PAYMENT_ITEM }]);
    const [moveData, setMoveData] = useState(
        {
            moveOutDate: "",
            moveOutReasonTypeId: undefined
        }
    );
    const navigate = useNavigate()
    const { id } = useParams()
    const { errors, setErrors, errorMessages, setErrorMessages, clearErrors } = useError();
    const orgId = sessionStorage.getItem(UserLoginData.organization_id)

    const moveId = isMoveOut ? moveOutId : moveInId
    const downloadDocument = (id, fileName) => {
        apiHelper(DocumentService.getApiDocumentBase641, { showNotification: false }, id)
            .then((docRes) => {
                convertStreamAndDownloadBymimeTypes(docRes?.data?.success, fileName)
            }).catch((docErr) => { });
    };
    const getTenantsData = async () => {
        let ID = tenantData?.id ?? id;

        const tenantsResponse = await apiHelper(TenantService.getApiTenant1, { showNotification: false }, Number(ID));
        const response = tenantsResponse?.data?.success
        if (response) {
            setUserData({
                ...tenantsResponse?.data?.success,
            });
            setLoadingStates((prevLoadingStates) => ({
                ...prevLoadingStates,
                userData: false,
            }));
            // getLeaseAgreement(response?.currentLeaseInfo?.id)
        }
    };

    const getLeaseAgreement = () => {
        if (show) {
            if (!leaseApplicationId) return;

            apiHelper(
                LeaseAgreementService.getApiLeaseAgreementFromLeaseApplication,
                { showNotification: false },
                leaseApplicationId
            ).then((res) => {
                if (res?.data?.success) {
                    setLeaseAgreementData(res.data.success);
                    setMoveInId(res.data.success.moveInId);
                    setMoveOutId(res.data.success.moveOutId);

                    const moveId = isMoveOut
                        ? res.data.success.moveOutId
                        : res.data.success.moveInId;

                    getTenantMoveData(moveId);
                }
            });
        } else {
            if (!userData?.currentLeaseAgreementId) return;

            apiHelper(
                TenantService.getApiTenantMoveFromLeaseAgreement,
                { showNotification: false },
                Number(userData.currentLeaseAgreementId)
            ).then((res) => {
                if (res?.data?.success) {
                    const moveData = res.data.success;
                    const returnedMoveTypeId = moveData.moveTypeId;

                    setLeaseAgreementData(moveData);

                    if (isMoveOut) {
                        if (returnedMoveTypeId === MoveTypesEnum.MoveOut) {
                            setMoveOutId(moveData.id);
                            getTenantMoveData(moveData.id);
                        } else {
                            setMoveOutId(undefined);
                        }
                    } else {
                        if (returnedMoveTypeId === MoveTypesEnum.MoveIn) {
                            setMoveInId(moveData.id);
                            getTenantMoveData(moveData.id);
                        } else {
                            setMoveInId(undefined);
                        }
                    }
                }
            });
        }
    };

    useEffect(() => {
        if (show) {
            if (leaseApplicationId) {
                getLeaseAgreement();
            }
        } else {
            if (userData?.currentLeaseAgreementId) {
                getLeaseAgreement();
            }
        }
    }, [show, leaseApplicationId, userData]);

    useEffect(() => {
        if (tenantMoveId) {
            getTenantMoveData(tenantMoveId);
        }
    }, [tenantMoveId]);

    const getTenantMoveData = (id) => {
        if (id) {
            apiHelper(TenantService.getApiTenantMove, { showNotification: false }, id)
                .then((res) => {
                    const successData = res?.data?.success
                    setExistingPaymentIds(successData.paymentDueAccountIds || []);
                    if (successData) {
                        getPaymentData(successData?.paymentDueAccountIds)
                        setPickupInstruction(successData?.keyInstructions)
                        setAdditionalInfo(successData?.additionalInfo)
                        setMoveData({
                            moveOutDate: successData?.moveDate,
                            moveOutReasonTypeId: successData?.moveReasonTypeId
                        })
                    }
                }).catch((err) => {

                })
        }
    }

    const getPaymentData = async (ids: number[]) => {
        if (!Array.isArray(ids) || ids.length === 0) return;

        try {
            const paymentRequests = ids.map(id =>
                apiHelper(
                    PaymentService.getApiPaymentDueAccount,
                    { showNotification: false },
                    id
                )
            );

            const responses = await Promise.all(paymentRequests);

            const payments = responses
                .map(res => res?.data?.success)
                .filter(Boolean)
                .map(payment => ({
                    id: payment.id,
                    dueDate: DateHelper.convertUTCtoDateTime2(payment.dueDate),
                    amount: payment.amount,
                    gracePeriods: payment.gracePeriodInDays,
                    description: payment.description,
                    paymentType: payment.paymentTypeId,
                    isNonRefundable: payment.isNonRefundable,
                }));

            setFormData(payments);
        } catch (error) {
            console.error("Error fetching payment data:", error);
        }
    };


    useEffect(() => {
        getTenantsData()
    }, [tenantData?.id, id])

    const checkEmptyFields = (validatePayments = true): boolean => {
        const newErrors = { ...errors };
        const newErrorMessages = { ...errorMessages };
        let hasErrors = false;
        if (validatePayments) {
            formData.forEach((payment, index) => {
                if (!payment?.dueDate) {
                    newErrors[`dueDate-${index}`] = true;
                    newErrorMessages[`dueDate-${index}`] = "Due date is required";
                    hasErrors = true;
                } else {
                    newErrors[`dueDate-${index}`] = false;
                }

                if (!payment.gracePeriods) {
                    newErrors[`gracePeriods-${index}`] = true;
                    newErrorMessages[`gracePeriods-${index}`] = "Grace period is required";
                    hasErrors = true;
                } else {
                    newErrors[`gracePeriods-${index}`] = false;
                }

                if (!payment.amount) {
                    newErrors[`amount-${index}`] = true;
                    newErrorMessages[`amount-${index}`] = "Amount is required";
                    hasErrors = true;
                } else {
                    newErrors[`amount-${index}`] = false;
                }

                if (!payment.description) {
                    newErrors[`description-${index}`] = true;
                    newErrorMessages[`description-${index}`] = "Description is required";
                    hasErrors = true;
                } else {
                    newErrors[`description-${index}`] = false;
                }

                if (!payment.paymentType) {
                    newErrors[`paymentType-${index}`] = true;
                    newErrorMessages[`paymentType-${index}`] = "Payment Type is required";
                    hasErrors = true;
                } else {
                    newErrors[`paymentType-${index}`] = false;
                }
            });
        }

        if (moveData?.moveOutDate?.trim() === "") {
            newErrors.moveOutDate = true;
            newErrorMessages.moveOutDate = `${isMoveOut ? "Move Out" : "Move In"} date is required`;
            hasErrors = true;
        } else {
            newErrors.moveOutDate = false;
        }
        if (moveData?.moveOutReasonTypeId == null) {
            newErrors.moveOutReasonTypeId = true;
            newErrorMessages.moveOutReasonTypeId = `${isMoveOut ? "Move Out" : "Move In"} reason is required`;
            hasErrors = true;
        } else {

            newErrors.moveOutReasonTypeId = false;
        }
        setErrors(newErrors);
        setErrorMessages(newErrorMessages);
        return hasErrors;
    };
    const hasAnyPaymentFilled = () =>
        formData.some(payment =>
            payment.paymentType ||
            payment.amount ||
            payment.dueDate ||
            payment.gracePeriods ||
            payment.description
        );

    const handleDeletePayment = useCallback(async (payment: any) => {
        const paymentId = payment?.id;
        const isExistingOnServer = typeof paymentId === 'number' && existingPaymentIds.includes(paymentId);

        if (isExistingOnServer) {
            try {
                await apiHelper(
                    PaymentService.deleteApiPaymentDueAccount,
                    { showNotification: true, successMessage: 'Payment removed successfully', failureMessage: 'Unable to delete payment' },
                    paymentId
                );
                setExistingPaymentIds(prev => prev.filter(id => id !== paymentId));
            } catch (err) {
                console.error('Error deleting payment:', err);
                return;
            }
        }

        setFormData(prev => {
            const next = prev.filter(p => p.id !== paymentId);
            return next.length > 0 ? next : [{ ...DEFAULT_PAYMENT_ITEM }];
        });
    }, [existingPaymentIds]);

    const getOrgPayeeAccountId = async () => {
        const res = await apiHelper(
            PaymentService.getApiPayeeAccountOrganizationlist,
            { showNotification: false },
            orgId,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            `IsOrganizationAccount==true`
        );

        return res?.data?.success?.[0]?.id;
    };

    const buildPaymentPayload = useCallback(
        (payment: PaymentFormItem, payeeAccountId: number, includeId: boolean, paymentIndex: number) => {
            // AccountNumber/ReferenceNumber are required by PaymentDueAccountVM.Validate for every
            // create/update; this form never collects them — mirror LeaseAgreementSettings generation.
            const accountNumber = `${orgId}-${userData?.id}-${payment.paymentType}`;
            const referenceNumber = `${userData?.id}-${Date.now()}-${paymentIndex}`;
            const payload: Record<string, unknown> = {
                entityTypeId: EntityType.Tenant,
                entityId: Number(userData?.id),
                paidFlowTypeId: PaidFlowTypesEnum.Receiveable,
                payeeAccountTypeId: PayeeAccountTypesEnum.Tenant,
                payeeAccountId,
                paymentTypeId: Number(payment.paymentType),
                description: payment.description,
                amount: Number(payment.amount),
                dueDate: new Date(payment.dueDate).toISOString(),
                gracePeriodInDays: Number(payment.gracePeriods),
                accountNumber,
                referenceNumber,
            };
            payload.isNonRefundable = Boolean(payment.isNonRefundable);
            if (includeId && payment.id) {
                payload.id = payment.id;
            }
            return payload;
        },
        [userData?.id, orgId]
    );

    const createPaymentDueAccounts = async () => {
        if (!hasAnyPaymentFilled()) return [];

        const payeeAccountId = await getOrgPayeeAccountId();
        if (!payeeAccountId) {
            throw new Error("Unable to find organization payee account");
        }

        const resultIds: number[] = [];
        const paymentsToUpdate = [];
        const paymentsToCreate = [];

        for (const payment of formData) {
            const hasData =
                payment.paymentType ||
                payment.amount ||
                payment.dueDate ||
                payment.gracePeriods ||
                payment.description;

            if (!hasData) continue;

            const isExisting = typeof payment.id === 'number' && existingPaymentIds.includes(payment.id);
            if (isExisting) {
                paymentsToUpdate.push(payment);
            } else {
                paymentsToCreate.push(payment);
            }
        }

        let paymentIndex = 0;

        if (paymentsToUpdate.length > 0) {
            const updatePromises = paymentsToUpdate.map(payment => {
                const index = paymentIndex++;
                return apiHelper(
                    PaymentService.putApiPaymentDueAccount,
                    { showNotification: false },
                    buildPaymentPayload(payment, payeeAccountId, true, index)
                );
            });
            const updateResults = await Promise.all(updatePromises);
            for (const res of updateResults) {
                const id = res?.data?.success?.id;
                if (id == null) {
                    throw new Error("Unable to save payment details");
                }
                resultIds.push(id);
            }
        }

        if (paymentsToCreate.length > 0) {
            const createPromises = paymentsToCreate.map(payment => {
                const index = paymentIndex++;
                return apiHelper(
                    PaymentService.postApiPaymentDueAccount,
                    { showNotification: false },
                    buildPaymentPayload(payment, payeeAccountId, false, index)
                );
            });
            const createResults = await Promise.all(createPromises);
            for (const res of createResults) {
                const id = res?.data?.success?.id;
                if (id == null) {
                    throw new Error("Unable to save payment details");
                }
                resultIds.push(id);
            }
        }

        setExistingPaymentIds(resultIds);
        setFormData(prev =>
            prev.map((payment, index) => ({
                ...payment,
                id: resultIds[index] || payment.id
            }))
        );
        return resultIds;
    };

    const buildTenantMovePayload = (paymentDueAccountIds, id = null, isCompleted = false) => ({
        ...Number(id) && { id },
        tenantId: Number(userData?.id),
        unitId: leaseAgreementData?.unitId || userData?.unitId,
        leaseAgreementId: isMoveOut
            ? userData?.currentLeaseAgreementId
            : leaseAgreementData?.id,
        moveTypeId: isMoveOut ? MoveTypesEnum.MoveOut : MoveTypesEnum.MoveIn,
        keyInstructions: pickupInstruction,
        additionalInfo,
        paymentDueAccountIds,
        moveDate: new Date(moveData?.moveOutDate).toISOString(),
        moveReasonTypeId: moveData?.moveOutReasonTypeId,
        isCompleted: isCompleted
    });

    const submitHandler = async () => {

        if (checkEmptyFields()) return;
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const paymentDueAccountIds = await createPaymentDueAccounts();
            const existingMoveId = moveId || tenantMoveId;

            const payload = buildTenantMovePayload(
                paymentDueAccountIds,
                existingMoveId,
                false
            );

            const apiCall = existingMoveId
                ? TenantService.putApiTenantMove
                : TenantService.postApiTenantMove;

            const res = await apiHelper(apiCall, {
                showNotification: true,
                successMessage: existingMoveId
                    ? "Update Changes Successfully"
                    : "Save Changes Successfully",
                failureMessage: "Unable to save changes",
            }, payload);

            setTenantMoveId(res?.data?.success?.id);
            if (res?.data?.success) {
                const newId = res.data.success.id;
                setTenantMoveId(newId);
                getTenantMoveData(newId);

                isMoveOut ? navigate(`/tenants/currenttenantdetails/${userData?.id}/${userData?.unitId || leaseAgreementData?.unitId}`) :
                    navigate(URLS.TENANTS);

                PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), {
                    type: NotificationType.None,
                    message: ""
                });
            }
        } catch (err: any) {
            PubSub.publish(TopicsEnum.Notification.toString(), {
                type: NotificationType.Failure,
                message: err?.message || "Unable to save payment details",
            });
            console.error("Error in submit handler:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    const completelMoveOut = async () => {
        if (isSaving) return;
        setIsSaving(true);
        let paymentDueAccountIds: number[] = [];
        try {
            paymentDueAccountIds = await createPaymentDueAccounts();
            let moveIdToUse = moveId || tenantMoveId;

            if (!moveIdToUse) {
                const payload = buildTenantMovePayload(paymentDueAccountIds, undefined, false);  // Change to false here
                const res = await apiHelper(
                    TenantService.postApiTenantMove,
                    { showNotification: false },
                    payload
                );

                if (!res?.data?.success) {
                    PubSub.publish(TopicsEnum.Notification.toString(), {
                        type: NotificationType.Failure,
                        message: "Unable to complete move",
                    });
                    return;
                }

                moveIdToUse = res.data.success.id;
                setTenantMoveId(moveIdToUse);
            }
            const payload = buildTenantMovePayload(paymentDueAccountIds, moveIdToUse, true);

            const completeRes = await apiHelper(
                TenantService.putApiTenantMove,
                {
                    showNotification: true,
                    successMessage: isMoveOut
                        ? "Successfully Move Out"
                        : "Successfully Move In",
                    failureMessage: "Unable to complete move",
                },
                payload
            );

            if (completeRes?.data?.success) {
                PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), {
                    type: NotificationType.Success,
                    message: isMoveOut ? "Moved Out Successfully" : "Moved In Successfully"
                });
                isMoveOut ? navigate(URLS.TENANTS, { replace: true }) :
                    navigate(`/tenants/currenttenantdetails/${userData?.id}/${userData?.unitId || leaseAgreementData?.unitId}`
                        , { replace: true });
            }
        } catch (err: any) {
            PubSub.publish(TopicsEnum.Notification.toString(), {
                type: NotificationType.Failure,
                message: err?.message || "Unable to save payment details",
            });
            await Promise.allSettled(
                [...paymentDueAccountIds].map((id) =>
                    PaymentService.deleteApiPaymentDueAccount(id)
                )
            );
            console.error("Error in completeMoveOut:", err);
        } finally {
            setIsSaving(false);
        }
    };

    const toggleAccordion = useCallback((section: keyof AccordionState) => {
        if (section === 'paymentInfoOpen' && !accordionState.notes) return;
        setAccordionState((prev) => ({
            ...prev,
            movein: section === "movein" ? !prev.movein : false,
            paymentInfoOpen: section === "paymentInfoOpen" ? !prev.paymentInfoOpen : false,
            notes: section === "notes" ? !prev.notes : false,
        }));
    }, [accordionState.notes]);

    return (
        <><div className='move_out_container'>
            {isMoveOut && (<>
                <div className={`tenant-card `}>
                    <div className="tenant-card-header">
                        <div className="tenant-avatar">
                            <div className="tenant-initials">{UtilHelper.getInitials(userData?.firstName + " " + userData?.lastName)}</div>
                        </div>
                        <div className="tenant-details">
                            <h3 className="tenant-name">{userData?.firstName + " " + userData?.lastName}</h3>
                            <p className="tenant-address">{userData?.streetAddress}</p>
                            <p className="tenant-contact">
                                {userData?.email + " • " + userData?.formatted?.PhoneNumber}
                            </p>
                        </div>
                    </div>
                </div>

                <LeftArrowTopHeader title={'Move Out'} backPath={-1} />

            </>)}
            <div className='moveOutContentSection'>
                <Accordion>
                    <AccordionSection
                        title={isMoveOut ? "Move Out Details" : "Move In Details"}
                        isOpen={accordionState.movein}
                        onToggle={() => toggleAccordion("movein")}
                    >
                        <MoveOutDetails
                            isMoveOut={isMoveOut}
                            moveOutDate={moveOutDate}
                            setMoveOutDate={setMoveOutDate}
                            moveOutReason={moveOutReason}
                            moveData={moveData}
                            setMoveData={setMoveData}
                            setMoveOutReason={setMoveOutReason}
                        />
                        <div className="footer-wrapper">
                            <SimpleButton type="button" label="Next"
                                onClick={() => {
                                    if (checkEmptyFields(false)) { return }
                                    setAccordionState({
                                        movein: false,
                                        paymentInfoOpen: true,
                                        notes: false
                                    })
                                }
                                } />
                        </div>
                    </AccordionSection>
                </Accordion>
                <Accordion>
                    <AccordionSection
                        title={isMoveOut ? "Final Payment(s)" : "Initial  Payment(s)"}
                        isDisabled={!accordionState.notes}
                        isOpen={accordionState.paymentInfoOpen}
                        onToggle={() => toggleAccordion("paymentInfoOpen")}
                    >
                        <div className="payment-form-scroll-area">
                            <DynamicAddMoreForm
                                showNonRefundable={isMoveOut ? true : false}
                                data={formData}
                                setData={setFormData}
                                onDeletePayment={handleDeletePayment}
                            />
                        </div>
                        <div className="footer-wrapper">
                            <SimpleButton type="button" label="Next"
                                onClick={() => {
                                    if (checkEmptyFields()) {
                                        return
                                    }
                                    setAccordionState({
                                        movein: false,
                                        paymentInfoOpen: false,
                                        notes: true
                                    })
                                }
                                    //  handleNextClick
                                } />
                        </div>
                    </AccordionSection>
                </Accordion>
                <Accordion>
                    <AccordionSection
                        title="Additional Information"
                        isDisabled={!accordionState.notes}
                        isOpen={accordionState.notes}
                        onToggle={() => toggleAccordion("notes")}
                    >
                        <InstructionsAndInfo
                            pickupInstruction={pickupInstruction}
                            setPickupInstruction={setPickupInstruction}
                            additionalInfo={additionalInfo}
                            setAdditionalInfo={setAdditionalInfo}
                        />
                        <div className="footer-wrapper p-4 gap-2">
                            <SimpleButton
                                onClick={() => {
                                    if (checkEmptyFields()) { return } else setShowModal(true)
                                }}
                                className={"btn-regular"}
                                isDisabled={isSaving}
                                label={isSaving ? "Saving..." : isMoveOut ? "Complete move out" : "Complete and move in"}
                                type="button"
                            />
                            <SimpleButton
                                onClick={() => submitHandler()}
                                className={"btn-outline-blue"}
                                isDisabled={isSubmitting}
                                label={isSubmitting ? "Saving..." : "Save Changes"}
                                type="button"
                            />
                        </div>
                    </AccordionSection>
                </Accordion>
                {/* </form> */}

            </div>
            {showModal && (
                <>
                    <ConfirmationPopup
                        isOpen={true}
                        title={isMoveOut ? "Move Out" : "Move In"}
                        message={`Are you sure you want to ${isMoveOut ? "Move out" : "Move in"} ${userData?.firstName || tenantData?.firstName} ${userData?.lastName || tenantData?.lastName}?`}
                        primaryButtonLabel="No"
                        secondaryButtonLabel="Yes"
                        onPrimaryAction={() => setShowModal(false)}
                        onSecondaryAction={() => completelMoveOut()}
                        onClose={() => setShowModal(false)}
                        isPrimaryAction={false}
                        isPrimaryDestructive={false}
                    />
                </>
            )}
        </div>
        </>
    )
}

export default MoveInAndOutContentBlocks